var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwoPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.46771C10.5374 1.85841 11.2477 1.42722 12.0362 1.2315C12.8247 1.03579 13.6542 1.08483 14.4142 1.37211C15.1741 1.65939 15.8286 2.17128 16.2905 2.83967C16.7524 3.50806 16.9998 4.30125 16.9998 5.11371C16.9998 5.92617 16.7524 6.71936 16.2905 7.38775C15.8286 8.05614 15.1741 8.56803 14.4142 8.85531C13.6542 9.14259 12.8247 9.19163 12.0362 8.99592C11.2477 8.8002 10.5374 8.36901 10 7.75971M13 19.1137H1V18.1137C1 16.5224 1.63214 14.9963 2.75736 13.8711C3.88258 12.7459 5.4087 12.1137 7 12.1137C8.5913 12.1137 10.1174 12.7459 11.2426 13.8711C12.3679 14.9963 13 16.5224 13 18.1137V19.1137ZM13 19.1137H19V18.1137C19.0001 17.0604 18.723 16.0256 18.1965 15.1134C17.6699 14.2012 16.9125 13.4436 16.0004 12.9169C15.0882 12.3902 14.0535 12.1129 13.0002 12.1129C11.9469 12.1128 10.9122 12.3901 10 12.9167M11 5.11371C11 6.17458 10.5786 7.19199 9.82843 7.94214C9.07828 8.69228 8.06087 9.11371 7 9.11371C5.93913 9.11371 4.92172 8.69228 4.17157 7.94214C3.42143 7.19199 3 6.17458 3 5.11371C3 4.05284 3.42143 3.03543 4.17157 2.28528C4.92172 1.53514 5.93913 1.11371 7 1.11371C8.06087 1.11371 9.07828 1.53514 9.82843 2.28528C10.5786 3.03543 11 4.05284 11 5.11371Z",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoPerson);
export default __webpack_public_path__ + "static/media/two-person.9786a2fd.svg";
export { ForwardRef as ReactComponent };